import "./shared/timezones/installCanadaPermanentTime"
import React from "react"
import ReactDOM from "react-dom"
import { ApolloProvider } from "@apollo/client"
import Modal from "react-modal"
import client from "./apolloClient"

import "@csstools/normalize.css" // see https://github.com/facebook/create-react-app/issues/9710
import "./index.scss"
import "./i18n"

import App from "./App"
import reportWebVitals from "./reportWebVitals"

Modal.setAppElement("#root")

const portalOverrides = require("portal.json")

const hasPortalOverrides = Object.keys(portalOverrides).length > 0

if (process.env.REACT_APP_WHITELABEL && !hasPortalOverrides) {
  const base = `${process.env.PUBLIC_URL}/assets/${process.env.REACT_APP_WHITELABEL}`
  document.querySelector('link[rel="icon"]').href = `${base}/favicon.ico`
  document.querySelector('link[rel="apple-touch-icon"]').href = `${base}/logo192.png`
}

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById("root")
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
